var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.245,
    height: 7.245,
    viewBox: "0 0 7.245 7.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VerifiedIcon",
    transform: "translate(-0.021 -0.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2.367,7.28h-1a.4.4,0,0,1-.4-.4v-1a.4.4,0,0,0-.118-.285L.14,4.885a.4.4,0,0,1,0-.571L.853,3.6a.379.379,0,0,0,.111-.268V2.325a.4.4,0,0,1,.4-.4h1A.4.4,0,0,0,2.652,1.8L3.359,1.1a.4.4,0,0,1,.571,0l.706.706a.4.4,0,0,0,.285.118h1a.4.4,0,0,1,.4.4v1a.4.4,0,0,0,.118.285l.706.706a.4.4,0,0,1,0,.571l-.706.706a.4.4,0,0,0-.118.285v1a.4.4,0,0,1-.4.4h-1a.4.4,0,0,0-.285.118l-.706.706a.4.4,0,0,1-.571,0L2.652,7.4A.4.4,0,0,0,2.367,7.28Z",
    fill: "#d7ff3e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M5.886,4.833l-1.66,1.66-.755-.755",
    transform: "translate(-0.883 -0.987)",
    fill: "#d7ff3e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M5.886,4.833l-1.66,1.66-.755-.755",
    transform: "translate(-0.883 -0.987)",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.299
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/VerifiedIcon.10821d29bd71b77fa577cab34bf3f9c8.svg";
export { ForwardRef as ReactComponent };